Object.defineProperty(exports, "__esModule", {value: true});

var js_Boot = require('./js/Boot');

exports.default = function $estr() {
	return js_Boot["__string_rec"](this, '');
}



//////////////////
// WEBPACK FOOTER
// ./lib/_gen/estr_stub.js
// module id = 263
// module chunks = 0